import { IconProps } from "@tfg/ui"

export const IconManufacturing = ({ size = 24, ...props }: IconProps) => (
  <svg
    id="manufacturing_svg__Calque_3"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {
        ".manufacturing_svg__st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round}"
      }
    </style>
    <path
      d="M37.3 36.8v-30c0-.3-.2-.5-.5-.5h-6.6c-.3 0-.5.2-.5.5v15.1c0 .1-.1.1-.2.1l-11.1-6.5c-.1 0-.2 0-.2.1V22c0 .1-.1.1-.2.1L7 15.4c-.1 0-.2 0-.2.1v21.2h26.4"
      style={{
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
      }}
    />
    <path
      className="manufacturing_svg__st1"
      d="M13.4 27.4h3.2c.3 0 .5.2.5.5v3.2c0 .3-.2.5-.5.5h-3.2c-.3 0-.5-.2-.5-.5v-3.2c0-.2.2-.5.5-.5zM25.3 27.4h3.2c.3 0 .5.2.5.5v3.2c0 .3-.2.5-.5.5h-3.2c-.3 0-.5-.2-.5-.5v-3.2c0-.2.3-.5.5-.5z"
    />
  </svg>
)
